import { createSlice } from '@reduxjs/toolkit';
import reducerTypes from '../reducerTypes';

const initialState = {
  selectedRegulation: null
};

export const adminSlice = createSlice({
  name: reducerTypes.admin,
  initialState,
  reducers: {
    SET_SELECTED_REGULATION: (state, data) => {
      state.selectedRegulation = data.payload;
    }
  },
});

export const { SET_SELECTED_REGULATION } = adminSlice.actions;

export default adminSlice.reducer;
